module.exports = __webpack_public_path__ + "static/img/4.cc980c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/4.png
// module id = xGkc
// module chunks = 45